import * as React from 'react';

window.React = React;
